import { StrictMode } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { useZoomAwareTheme } from "@thalamos/frontend";

import "./i18n.js";

import { ToastProvider } from "./components/ToastProvider/ToastProvider.js";
import { createRouter } from "./routing/createRouter.js";
import { theme as defaultTheme } from "./theme/defaultTheme.js";
import { initialiseTracing } from "./tracing.js";

const router = createRouter();

initialiseTracing();

const App = () => {
  const theme = useZoomAwareTheme(defaultTheme);

  return (
    <StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </ThemeProvider>
    </StrictMode>
  );
};

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(rootElement).render(<App />);
